import React from 'react';
import styled from 'styled-components/macro';
import { space, SpaceProps } from 'styled-system';

import BookingTimerClock from './BookingTimerClock';
import useTypeSafeLocalize from '../Hooks/use-type-safe-localize';
import { LocalizationCategory, ProductLocalization } from '../localizations/types';
import { useGetCustomBookingLocalization } from '../Hooks/use-get-custom-booking-localization';
import { BookingLocalization } from '../Utils/graphql-sdk';
import { Label, Text } from '../SubComponents/Text';

const boxShadow = '0 4px 6px rgba(50, 50, 93, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1)';

const BookingTimerWrapper = styled.div<SpaceProps & { flatTop?: boolean }>`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 16px;
  padding: 16px;

  background-color: ${(props) => props.theme.colors.bookingTimer.backgroundColor};
  border: 2px solid ${(props) => props.theme.colors.bookingTimer.borderColor};
  border-radius: 8px;
  box-shadow: ${(props) => (props.theme.shadows ? boxShadow : 'none')};

  ${(props) => (props.flatTop ? 'border-top: none;' : null)}
  ${(props) => (props.flatTop ? 'border-top-left-radius: 0;' : null)}
  ${(props) => (props.flatTop ? 'border-top-right-radius: 0;' : null)}

  ${space}
`;

export interface BookingTimerProps extends SpaceProps {
  modifiedDate?: string | null;
  expiresDate?: string | null;
  flatTop?: boolean;
}

const BookingTimer = (props: BookingTimerProps) => {
  const { modifiedDate, expiresDate, ...rest } = props;
  const localize = useTypeSafeLocalize();
  const getCustomBookingLocalization = useGetCustomBookingLocalization();

  if (!modifiedDate || !expiresDate) return null;

  return (
    <BookingTimerWrapper {...rest}>
      <Text renderWhiteSpace>
        <Label bold>
          {getCustomBookingLocalization(BookingLocalization.SailoutTimeReservedHeading) ||
            localize(
              LocalizationCategory.product,
              ProductLocalization.bookingHeldHeading
            )}
        </Label>
        <br />
        {getCustomBookingLocalization(BookingLocalization.SailoutTimeReservedText) ||
          localize(LocalizationCategory.product, ProductLocalization.bookingHeldText)}
      </Text>

      <BookingTimerClock modifiedDate={modifiedDate} expiresDate={expiresDate} />
    </BookingTimerWrapper>
  );
};

export default BookingTimer;
